import { useAppDispatch } from '../../../../redux/hooks'
import { FC, useContext, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { ScreenContext } from 'react-components'
import { useTranslation } from '../../../../hooks/locale'
import { popModal, getCurrentOpenedFilterModal } from '../../../../redux/filters'
import { FilterModalType } from '../../../app-components/filter-sort-section/types'
import {
    CancellationPolicyReadMoreModal,
    CancellationPolicyHeader,
    CancellationPolicyIcon,
    CancellationPolicyText,
    CancellationPolicyCloseIcon,
    PolicyPoints,
    NewTagContainer,
    NewTagText,
    NewTagIcon,
} from '../../../app-components/filter-sort-section/styles'

interface Props {
    title: string
    policyPoints: string
}

const CancellationPolicyModal: FC<Props> = ({ title, policyPoints }) => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const { isMobile } = useContext(ScreenContext)
    const isOpen = useSelector(getCurrentOpenedFilterModal) === FilterModalType.CANCELLATION_POLICY

    const handleClose = useCallback(() => {
        dispatch(popModal())
    }, [dispatch])

    return (
        <CancellationPolicyReadMoreModal isOpen={isOpen} onRequestClose={handleClose}>
            <CancellationPolicyHeader>
                <CancellationPolicyIcon />
                <CancellationPolicyText>
                    {title}
                    {!isMobile && (
                        <NewTagContainer>
                            <NewTagText>{t('new')}</NewTagText>
                            <NewTagIcon aria-label="new tag icon" />
                        </NewTagContainer>
                    )}
                </CancellationPolicyText>
                {!isMobile && <CancellationPolicyCloseIcon onClick={handleClose} />}
            </CancellationPolicyHeader>
            <PolicyPoints inputText={policyPoints} escapeHtml />
        </CancellationPolicyReadMoreModal>
    )
}

export default CancellationPolicyModal
